"use strict";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
import mask from '@alpinejs/mask'

import Trix from "trix/dist/trix.esm";

/*import Quill from "quill";*/
import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de";
import '@nextapps-be/livewire-sortablejs';

import SimpleLightbox from "simplelightbox";

// require('./bootstrap');

// require('select2');

flatpickr.localize(German);
window.flatpickr = flatpickr;

/*window.Quill = Quill;*/
window.Trix = Trix;
window.SimpleLightbox = SimpleLightbox;

window.Alpine = Alpine;
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.plugin(intersect)
Alpine.plugin(mask);

Alpine.data('cookie', () => ({
    marketing: false,
    statistics: false,
    setCookies(marketing, statistics) {
        this.marketing = marketing;
        this.statistics = statistics;
    },
    renewing() {
        setTimeout(() => {
            if (Cookiebot && Cookiebot.consent) {
                this.marketing = Cookiebot.consent.marketing
                this.statistics = Cookiebot.consent.statistics

                // if (Cookiebot.consent.statistics) {
                //     this.loadTagManager();
                // }
            }
        }, 5000)
    },
    renew() {
        if (Cookiebot) {
            Cookiebot.renew()
            setTimeout(() => {
                this.marketing = Cookiebot.consent.marketing
                this.statistics = Cookiebot.consent.statistics

                // if (Cookiebot.consent.statistics) {
                //     this.loadTagManager();
                // }
            }, 5000)
        }
    },
    loadTagManager() {
        let tag = document.getElementById('googletagmanager');
        tag.innerHTML = "(function(w,d,s,l,i){" +
            "w[l]=w[l]||[];w[l].push({'gtm.start':" +
            "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
            "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
            "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
            "})(window,document,'script','dataLayer','GTM-T6SQJC8');";
        // (function (w, d, s, l, i) {
        //     w[l] = w[l] || [];
        //     w[l].push({
        //         'gtm.start':
        //             new Date().getTime(), event: 'gtm.js'
        //     });
        //     var f = d.getElementsByTagName(s)[0],
        //         j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        //     j.async = true;
        //     j.src =
        //         'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        //     f.parentNode.insertBefore(j, f);
        // })(window, document, 'script', 'dataLayer', 'GTM-T6SQJC8')
    },
    init() {
        // debug:
        // this.loadTagManager();

        if (typeof Cookiebot !== 'undefined' && Cookiebot) {
            if (Cookiebot.consent && Cookiebot.consent.statistics) {
                this.loadTagManager();
            }
        }
        window.addEventListener('CookiebotOnAccept', function (e) {
            this.marketing = Cookiebot.consent.marketing;
            this.statistics = Cookiebot.consent.statistics;

            window.dispatchEvent(new CustomEvent('cookies-updated', { detail: { marketing: Cookiebot.consent.marketing, statistics: Cookiebot.consent.statistics } }));

            if (Cookiebot.consent && Cookiebot.consent.statistics) {
                // this.loadTagManager();
                let tag = document.getElementById('googletagmanager');
                tag.innerHTML = "(function(w,d,s,l,i){" +
                    "w[l]=w[l]||[];w[l].push({'gtm.start':" +
                    "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
                    "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
                    "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
                    "})(window,document,'script','dataLayer','GTM-T6SQJC8');";
            }
        }, false);
        window.addEventListener('CookiebotOnDecline', function (e) {
            this.marketing = Cookiebot.consent.marketing;
            this.statistics = Cookiebot.consent.statistics;
            window.dispatchEvent(new CustomEvent('cookies-updated', { detail: { marketing: Cookiebot.consent.marketing, statistics: Cookiebot.consent.statistics } }));
        }, false);
    }
}))

Alpine.start();

document.addEventListener('scrollToError', function () {
    document.getElementsByClassName('invalid-feedback')[0].scrollIntoView({
        behaviour: "smooth",
        block: "center",
        inline: "center"
    });
});

document.addEventListener('touchstart', window.ontouchstart, { passive: true });
